import { ChangeEventHandler } from 'react';

import IconPlus from 'approot/shared/icons/icon-plus';
import IconMinus from 'approot/shared/icons/icon-minus';
import * as Styled from './range.style';

type RangeValues = {
  value: number;
  min: number;
  max: number;
};

type BaseProps = {
  id: string;
  isDisabled?: boolean;
  step?: string | number;
  handleChange?: ChangeEventHandler<HTMLInputElement>;
} & RangeValues;

type RangeProps = BaseProps & {
  onDecrement: () => void;
  onIncrement: () => void;
};

const RangeTrack = ({ value, min, max }: RangeValues) => (
  <>
    <Styled.RangeTrack></Styled.RangeTrack>
    <Styled.RangeTrackFiller>
      <Styled.RangeTrackFillerWrapper
        style={{
          width: `${((value - min) / (max - min)) * 100}%`,
        }}
      >
        <Styled.RangeTrackKnob></Styled.RangeTrackKnob>
      </Styled.RangeTrackFillerWrapper>
    </Styled.RangeTrackFiller>
  </>
);

const Range = ({
  id,
  value,
  min,
  max,
  isDisabled,
  step = 'any',
  handleChange,
  onDecrement,
  onIncrement,
}: RangeProps) => (
  <Styled.RangeSlider>
    <Styled.RangeButton
      aria-label="Reduce size"
      disabled={isDisabled}
      onClick={onDecrement}
      type="button"
    >
      <IconMinus width={14} height={14} />
    </Styled.RangeButton>
    <Styled.RangeField
      type="range"
      min={min}
      value={value}
      max={max}
      disabled={isDisabled}
      onChange={handleChange}
      step={step}
      id={id}
    />
    <Styled.RangeContent>
      <RangeTrack min={min} value={value} max={max} />
    </Styled.RangeContent>
    <Styled.RangeButton
      aria-label="Increase size"
      disabled={isDisabled}
      onClick={onIncrement}
      type="button"
    >
      <IconPlus width={14} height={14} />
    </Styled.RangeButton>
  </Styled.RangeSlider>
);

export default Range;

export const RangeSlider = ({
  id,
  value,
  min,
  max,
  isDisabled,
  step = 'any',
  handleChange,
}: BaseProps) => (
  <Styled.RangeContentSliderWrapper>
    <Styled.RangeField
      type="range"
      min={min}
      value={value}
      max={max}
      disabled={isDisabled}
      onChange={handleChange}
      step={step}
      id={id}
    />
    <Styled.RangeContentSlider>
      <RangeTrack min={min} value={value} max={max} />
    </Styled.RangeContentSlider>
  </Styled.RangeContentSliderWrapper>
);
